import {mapState} from 'vuex'
import {filters} from "../filters";

export const usersInAccount = {
  mixins: [filters],
  computed: {
    ...mapState({
      usersLoaded: state => state.roles.users,
      usersInvited: state => state.roles.invitedUsers,
      rolesData: state => state.roles.ownedRoles

    }),
    usersArr() {
      return this.delDouble(this.usersLoaded
        .concat(this.usersInvited)
        .map(item => {
          let name = `${item.first_name} ${item.second_name}`
          if (name == 'null null') {
            name = item.contacts.email
          };
          return {
            name: name,
            id: item.id,
            email: item.contacts.email,
          }
        }), 'id')
    },
    rolesArr() {
      return this.rolesData.map(item => {
        return {
          name: `${item.name}`,
          id: item.id,
        }
      })
    },
  }
}
